export default __webpack_public_path__ + "static/media/tkmt.bd280f71.png";